// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';

import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AccountPage from './pages/AccountPage';
import Home from './pages/Home';
import TokensPage from './pages/TokensPage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import AvisoLegal from './pages/AvisoLegal';
import PoliticaCookies from './pages/PoliticaCookies';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import PoliticaTienda from './pages/PoliticaTienda';

// NUEVOS IMPORTS - Componentes para admin y 404
import AdminOrders from './components/AdminOrders';
import NotFound from './components/NotFound';

import "@solana/wallet-adapter-react-ui/styles.css";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app-container">
          <Header />

          <Routes>
            {/* Rutas principales */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/tokens" element={<TokensPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/about" element={<AboutPage />} />
            
            {/* Rutas legales */}
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-tienda" element={<PoliticaTienda />} />
            
            {/* Ruta oculta para ADMIN - SOLO usuarios con rol sys_admin */}
            <Route path="/home/config_view_products" element={<AdminOrders />} />
            
            {/* Página 404 - Para rutas no encontradas */}
            <Route path="/404" element={<NotFound />} />
            
            {/* Redirección para cualquier ruta no definida a 404 */}
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>

          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;